// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__eZJnw","ellipsis":"styles_ellipsis__T7xF_","text2AndMoreLines":"styles_text2AndMoreLines__3XGnN","tooltipTrigger":"styles_tooltipTrigger__6_RqS"};